import { Body, Box, BoxProps, Divider, Heading, Link } from '@hover/blueprint';
import React from 'react';
import { URLS } from '../../../../constants';
import ArrowButton from '../../../ui/ArrowButton';
import Mobile from './Mobile';
import TabletAndDesktop from './TabletAndDesktop';

interface Props extends BoxProps {}

const Premium: React.FC<Props> = props => (
  <Box
    w={{ base: '100%', tablet: '353px', desktop: '380px' }}
    position="relative"
    borderRadius="8px"
    shadow="distance300"
    flexDir="column"
    overflow="hidden"
    {...props}
  >
    <Box position="absolute" top={0} bg="brandBrown.500" h={50} w="100%" />
    <Box
      pt={{ base: 600, tablet: '78px' }}
      px={{ base: '28px', desktop: 700 }}
      flexDir="column"
      alignItems="center"
      bg="primary.600"
      w="100%"
    >
      <Heading
        size={{ base: 500, tablet: 600 }}
        marginBottom={{ base: 400, tablet: 500 }}
        color="neutral.0"
      >
        Membership
      </Heading>
      <Body
        color="neutral.0"
        size={{ base: 500, tablet: 600 }}
        marginBottom={{ base: 500, tablet: 600 }}
        textAlign="center"
      >
        Expanded tools and features with dedicated support to power your
        workflow.
      </Body>
      <ArrowButton
        as={Link}
        href={URLS.pricing.contactSales}
        colorScheme="primary"
        mb={{ base: 400, tablet: 600 }}
        variant="inverted"
        w={{ base: '286px', tablet: '230px' }}
      >
        Contact sales
      </ArrowButton>
    </Box>
    <Box
      px={{ base: 700, tablet: '45px', desktop: '57px' }}
      bg={{ base: 'primary.600', tablet: 'neutral.0' }}
    >
      <Body
        textAlign="center"
        mt={{ base: 0, tablet: 600 }}
        size={{ base: 500, tablet: 600 }}
        mb={{ base: 400, tablet: 500 }}
        color={{ base: 'neutral.0', tablet: 'neutral.700' }}
        isSemiBold
        mx="auto"
      >
        Discounted property rates, with membership fee
      </Body>
    </Box>
    <Box bg={{ base: 'primary.600', tablet: 'neutral.0' }} px={400}>
      <Divider borderColor={{ base: 'neutral.0', tablet: 'neutral.300' }} />
    </Box>
    <Mobile />
    <TabletAndDesktop />
  </Box>
);

export default Premium;
